import type { ServiceStatusTypes } from '../services/constants/ServiceStatusTypes';
export type { ServiceStatusTypes };

export const baseServiceStatusTypesEnum = {
    CANCELLED: 'Cancelled',
    NONE: 'None',
    REQUEST: 'Request',
    OK: 'OK',
    WAITING_LIST: 'Waiting List',
    SOLD_OUT: 'Sold Out',
    TRANSPARENT: 'Transparent',
    ALL: 'All'
} as const;

export type BaseServiceStatusTypesKeys = keyof typeof baseServiceStatusTypesEnum;

export type BaseServiceStatusTypes = (typeof baseServiceStatusTypesEnum)[BaseServiceStatusTypesKeys];

export const baseServiceStatusTypesOptions = Object.values(baseServiceStatusTypesEnum);
